var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#101820;}\r\n")), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.9,27H10.1c-1.2,0-2.2-1-2.2-2.2v-14c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v14 c0,0.4,0.3,0.7,0.7,0.7h11.8c0.4,0,0.7-0.3,0.7-0.7v-14c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v14C24.1,26,23.1,27,21.9,27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.8,9.4H7.2c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7h17.6c0.4,0,0.7,0.3,0.7,0.7 C25.6,9.1,25.2,9.4,24.8,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.9,9.4c-0.4,0-0.7-0.3-0.7-0.7V6.4h-4.4v2.2c0,0.4-0.3,0.7-0.7,0.7s-0.7-0.3-0.7-0.7V5.7 c0-0.4,0.3-0.7,0.7-0.7h5.9c0.4,0,0.7,0.3,0.7,0.7v2.9C19.7,9.1,19.3,9.4,18.9,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,23.4c-0.4,0-0.7-0.3-0.7-0.7V12.3c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v10.3 C16.7,23,16.4,23.4,16,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.7,21.9c-0.4,0-0.7-0.3-0.7-0.7v-7.4c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v7.4 C20.4,21.6,20.1,21.9,19.7,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.3,21.9c-0.4,0-0.7-0.3-0.7-0.7v-7.4c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7v7.4 C13.1,21.6,12.7,21.9,12.3,21.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBasket);
export default __webpack_public_path__ + "static/media/deleteBasket.f43bd53a1f2b888533c20f53f21e5557.svg";
export { ForwardRef as ReactComponent };